import { type InputHTMLAttributes } from 'react';
import styles from './Toggle.module.css';

interface ToggleProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

export function Toggle({ label, className = '', ...rest }: ToggleProps): JSX.Element {
  return (
    <label className={`${styles.wrap} ${className}`}>
      {label && <span className={styles.label}>{label}</span>}
      <span className={styles.switch}>
        <input type="checkbox" className={styles.input} {...rest} />
        <span className={styles.thumb} />
      </span>
    </label>
  );
}
